module.exports = __webpack_public_path__ + "img/2x.8db4072.jpg";